export default __webpack_public_path__ + "static/bJxCnhYu-84a6e26b8c5021be16d15fff336f6ca9.svg";